import { EventAttachmentDto } from '@oncolens/oncolens-ui/lib/dto/attachments/Attachment';
import { RequestStatus } from '@oncolens/oncolens-ui/lib/dto/event/request';
import { createStore, FormStoreProps } from '@oncolens/oncolens-ui/lib/libraries/FormStore';
import { RequestDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import schema from '../../config/request';

export interface RequestFormStoreValues {
  id: string | null;
  patient: any;
  submitTo: any;
  templateId: string | null;
  organizationId: string | null;
  workflowId: string | null;
  submissionId: string | null;
  preferredPhysciainId: string | null;
  isPending: boolean;
  attachments: EventAttachmentDto[];
  status: RequestStatus | null;
  hasGivenConsent: boolean | undefined;
}

const store = createStore<RequestFormStoreValues>(
  {
    id: null,
    patient: {},
    submitTo: {
      highPriority: false,
      reasonsForRequest: ''
    },
    templateId: null,
    organizationId: null,
    workflowId: null,
    submissionId: null,
    preferredPhysciainId: null,
    isPending: true,
    attachments: [],
    status: null,
    hasGivenConsent: false
  },
  schema
);

export function genesisStoreHydrate(state: FormStoreProps<RequestFormStoreValues>, data: RequestDto) {
  state.id = data.id;
  state.patient = {
    id: data.patient.id,
    sexId: data.patient.sexId,
    raceId: data.patient.raceId,
    ethnicityId: data.patient.ethnicityId,
    age: data.patient.age,
    zip: data.patient.zip
  };

  state.submitTo = {
    reasonsForRequest: data.topicForDiscussion,
    highPriority: data.isHighPriority,
    preferredPhysicianId: data.preferredPhysicianId
  };

  state.submissionId = data.displayInternalId;
  state.workflowId = data.workflowId;
  state.organizationId = data.organizationId;
  state.isPending = data.isPending;
  state.status = data.status;
}

export { store as default };
